import { AfterViewInit, Component, inject, Injector, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { GroupBrandService } from './core/services/group-brand.service';
import { AVAILABLE_PROVIDERS } from './shared/constants/provider.constants';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  protected readonly title = signal('MarketConnector');

  constructor() {
    // Padrão global: dropdown do ng-select no <body>, senão fica atrás/cortado
    // pelos stacking contexts e overflow dos cards do layout Sneat.
    inject(NgSelectConfig).appendTo = 'body';

    // Instancia a marca do grupo no bootstrap: aplica --mc-group* já com a empresa persistida.
    inject(GroupBrandService);

    // Pré-carrega os logos dos marketplaces (SVGs pequenos): avatares dos selects/grids abrem
    // sem o "pisca" de imagem carregando na primeira vez.
    for (const provider of AVAILABLE_PROVIDERS) {
      if (provider.logo) new Image().src = provider.logo;
    }
  }

  // Remove o splash de troca de empresa (index.html) assim que o Angular pinta a primeira tela,
  // fazendo fade-out suave. A flag é consumida aqui para não reaparecer num F5 posterior.
  ngAfterViewInit(): void {
    const splash = document.getElementById('mc-switch-splash');
    if (!splash) return;

    sessionStorage.removeItem('mc_switch');
    if (splash.style.display === 'none') return;

    splash.style.transition = 'opacity .28s ease';
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 300);
  }
}
